import type { SnapshotItem } from '@containd/shared';
import type { ItemDefinition } from '../shims/ItemDefinition';

/** Map public-share snapshot item → pipeline ItemDefinition. */
export function snapshotItemToPipelineItem(
  item: SnapshotItem,
  opts?: { localId?: number },
): ItemDefinition {
  const g = item.geometry;
  return {
    id: opts?.localId ?? 1,
    parentId: null,
    collectionShareId: item.uuid,
    templateId: item.templateId,
    templateElementId: item.templateElementId,
    title: item.title,
    description: item.description ?? '',
    amount: item.amount ?? 0,
    x: g.x,
    y: g.y,
    width: g.width,
    height: g.height,
    rotationDeg: g.rotationDeg ?? 0,
    zIndex: g.zIndex ?? 0,
    borderRadius: g.borderRadius ?? 8,
    frameThickness: g.frameThickness ?? 2,
    backgroundColor: g.backgroundColor ?? '#2d2d2d',
    borderColor: g.borderColor ?? '#555555',
    textColor: g.textColor ?? '#ffffff',
    fontSize: g.fontSize ?? 14,
    categories: item.categoryIds,
    tagList: item.tagIds,
    arbitraryFieldsList: item.arbitraryFieldsList ?? [],
    imageUris: [],
    layoutInUse: item.layoutInUse,
    ...(item.animateImages === true ? { animateImages: true } : {}),
  };
}
